import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Table, Modal, Checkbox, Button } from "antd";
import { SettingOutlined, ArrowUpOutlined, ArrowDownOutlined } from "@ant-design/icons";

const ColumnManagerTable = ({
                                pageKey,
                                columnsConfig,
                                data,
                                loading,
                                pagination,
                                onChange,
                                rowKey = "id"
                            }) => {

    const STORAGE_KEY = `column_config_${pageKey}`;

    const [columnsState, setColumnsState] = useState([]);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const saved = localStorage.getItem(STORAGE_KEY);

        if (saved) {
            setColumnsState(JSON.parse(saved));
        } else {
            setColumnsState(columnsConfig);
        }
    }, [columnsConfig]);

    const saveConfig = (newConfig) => {
        setColumnsState(newConfig);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(newConfig));
    };

    const toggleColumn = (key) => {
        const updated = columnsState.map(col =>
            col.key === key ? { ...col, checked: !col.checked } : col
        );
        saveConfig(updated);
    };

    const moveColumn = (index, direction) => {
        const newArr = [...columnsState];
        const target = index + direction;

        if (target < 0 || target >= newArr.length) return;

        [newArr[index], newArr[target]] = [newArr[target], newArr[index]];
        saveConfig(newArr);
    };

    const finalColumns = columnsState
        .filter(c => c.checked || c.key === "action")
        .map(c => c.column);

    return (
        <>
            <Button
                icon={<SettingOutlined />}
                onClick={() => setOpen(true)}
                style={{ marginBottom: 10 }}
            >
                Manage Columns
            </Button>

            <Table
                columns={finalColumns}
                dataSource={data}
                loading={loading}
                rowKey={rowKey}
                pagination={pagination}
                onChange={onChange}
            />

            <Modal
                title="Customize Columns"
                open={open}
                onCancel={() => setOpen(false)}
                footer={null}
            >
                {columnsState.map((col, index) => (
                    <div
                        key={col.key}
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: 10
                        }}
                    >
                        <Checkbox
                            checked={col.checked}
                            onChange={() => toggleColumn(col.key)}
                        >
                            {col.title}
                        </Checkbox>

                        <div>
                            <Button
                                size="small"
                                icon={<ArrowUpOutlined />}
                                onClick={() => moveColumn(index, -1)}
                            />
                            <Button
                                size="small"
                                icon={<ArrowDownOutlined />}
                                onClick={() => moveColumn(index, 1)}
                                style={{ marginLeft: 5 }}
                            />
                        </div>
                    </div>
                ))}
            </Modal>
        </>
    );
};

export default ColumnManagerTable;

ColumnManagerTable.propTypes = {
    pageKey: PropTypes.string.isRequired,
    columnsConfig: PropTypes.array.isRequired,
    data: PropTypes.array,
    loading: PropTypes.bool,
    pagination: PropTypes.object,
    onChange: PropTypes.func,
    rowKey: PropTypes.string
};